module.exports = __webpack_public_path__ + "img/Feature.393cec82.jpg";